import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  Button,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import config from "../../config/config";
import "./category.scss";

const EditCategory = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [breadcrumbItems] = useState([
    { title: "Categories", link: "/categories" },
    { title: "Edit Category", link: "#" },
  ]);
  const [formData, setFormData] = useState({
    category_name: "",
    category_image: null,
    category_type: "Domestic", // default
  });
  const [imagePreview, setImagePreview] = useState("");

  useEffect(() => {
    fetchCategoryData();
  }, []);

  const fetchCategoryData = async () => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/categories/${id}`);
      const data = await response.json();
      setFormData({
        category_name: data.category_name || "",
        category_type: data.category_type || "Domestic",
        category_image: null,
      });
      setImagePreview(data.category_image ? `${config.IMAGE_URL}/${data.category_image}` : "");
    } catch (error) {
      console.error('Error fetching category:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleTypeChange = (e) => {
    setFormData(prev => ({
      ...prev,
      category_type: e.target.value
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({
        ...prev,
        category_image: file
      }));
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    formDataToSend.append('category_name', formData.category_name);
    formDataToSend.append('category_type', formData.category_type);
    if (formData.category_image) {
      formDataToSend.append('category_image', formData.category_image);
    }

    try {
      const response = await fetch(`${config.API_BASE_URL}/categories/${id}`, {
        method: 'PUT',
        body: formDataToSend
      });

      if (response.ok) {
        navigate('/categories');
      } else {
        console.error('Failed to update category');
      }
    } catch (error) {
      console.error('Error updating category:', error);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Edit Category"
            breadcrumbItems={breadcrumbItems}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Form onSubmit={handleSubmit} className="category-form">
                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label className="form-label">State / Country Name</Label>
                          <Input
                            type="text"
                            className="form-control"
                            placeholder="Enter State / Country Name"
                            name="category_name"
                            value={formData.category_name}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label className="form-label">Category Type</Label>
                          <Input
                            type="select"
                            className="form-control"
                            name="category_type"
                            value={formData.category_type}
                            onChange={handleTypeChange}
                            required
                          >
                            <option value="Domestic">Domestic</option>
                            <option value="International">International</option>
                          </Input>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="mb-3">
                          <Label className="form-label">Category Image</Label>
                          <Input
                            type="file"
                            className="form-control"
                            name="category_image"
                            onChange={handleImageChange}
                            accept="image/*"
                          />
                          {imagePreview && (
                            <img
                              src={imagePreview}
                              alt="Category Preview"
                              className="img-fluid mt-2"
                              style={{ maxHeight: "200px" }}
                            />
                          )}
                        </div>
                      </Col>
                    </Row>

                    <Row className="mt-4">
                      <Col className="d-flex justify-content-end">
                        <Button type="submit" color="primary" className="me-2">
                          Update Category
                        </Button>
                        <Button
                          type="button"
                          color="secondary"
                          onClick={() => navigate('/categories')}
                        >
                          Cancel
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EditCategory;